/**
 * End of Life (EOL) create form does not include phase / GenAI groups, but
 * `formValues` can still carry these keys when the user switches moment type.
 * Strip them from the POST body so the API never receives them for EOL.
 */
import { MOMENT_TYPES } from 'utils/constants';

export const END_OF_LIFE_MOMENT_TYPE = MOMENT_TYPES.END_OF_LIFE;

const EOL_CREATE_EXCLUDED_KEYS = [
  'gaPhaseInfo',
  'genAiInfo',
  'internalBetaPhaseInfo',
  'privateBetaPhaseInfo',
  'publicBetaPhaseInfo'
] as const;

export function omitEolDisallowedPayloadKeys(
  payload: Record<string, unknown>
): void {
  for (const key of EOL_CREATE_EXCLUDED_KEYS) {
    delete payload[key];
  }
}
